import { EmteriaRoles } from "src/data/roles";
import i18next from "src/i18n/config";
import RouteService from "src/services/routeService";
import { invalidateOnSuccess, transformErrorResponse } from "src/store/helpers";
import { BasicApiResponse, PaginatedResponse } from "src/types";

import { AdminBuilder } from "./tags";

type RoleParams = {
    id: string;
    role: string;
};

const roles = (builder: AdminBuilder) => ({
    getRoles: builder.query<EmteriaRoles[], void>({
        providesTags: ["Roles"],
        transformErrorResponse: (err) => transformErrorResponse(err, i18next.t("common:error.technicalDifficulties.message")),
        transformResponse: (response: PaginatedResponse<EmteriaRoles>) => response.list,
        query: async () => {
            const base = await RouteService.getSecurityRoute();
            return { url: `${base}roles` };
        },
    }),

    assignRole: builder.mutation<BasicApiResponse, RoleParams>({
        invalidatesTags: invalidateOnSuccess("Accounts"),
        transformErrorResponse: (err) => transformErrorResponse(err, i18next.t("pages:adminRolesPage.toast.assignRoleError")),
        query: async ({ id, role }) => {
            const base = await RouteService.getAdminAccountsRoute();
            return { url: `${base}${id}/roles`, method: "POST", data: { role } };
        },
    }),

    removeRole: builder.mutation<BasicApiResponse, RoleParams>({
        invalidatesTags: invalidateOnSuccess("Accounts"),
        transformErrorResponse: (err) => transformErrorResponse(err, i18next.t("pages:adminRolesPage.toast.removeRoleError")),
        query: async ({ id, role }) => {
            const base = await RouteService.getAdminAccountsRoute();
            return { url: `${base}${id}/roles/${role}`, method: "DELETE" };
        },
    }),
});

export default roles;
